var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CustomModal",
    {
      staticClass: "basic-modal add-to-series-modal",
      attrs: {
        id: "add-to-series-modal",
        "ok-disabled": _vm.saveDisabled,
        "ok-busy": _vm.busy,
        "ok-title": _vm.$t("common.save")
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.save()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "add-to-series-modal__title",
          attrs: { slot: "modal-header" },
          slot: "modal-header"
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("publishers.modal.add_to_series.title")) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("LoadingBounce"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "typography--body-2 typography--color-disabled pb-5"
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.loading")) + "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "add-to-series-modal__series-list scroll-box" },
            [
              _vm._l(_vm.seriesList, function(seriesItem) {
                return _c("SeriesListItem", {
                  key: seriesItem.id,
                  attrs: {
                    "series-item": seriesItem,
                    "is-active": _vm.selectedSeriesId === seriesItem.id,
                    "selected-chapter-id": _vm.selectedChapterId
                  },
                  on: {
                    "select-series": _vm.selectSeries,
                    "select-chapter": _vm.selectChapter
                  }
                })
              }),
              _vm._v(" "),
              _c(
                "InfiniteLoading",
                {
                  ref: "infiniteLoading",
                  staticClass: "w-100",
                  attrs: { "on-infinite": _vm.onInfinite }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "spinner" }, slot: "spinner" },
                    [
                      _c("LoadingBounce"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-2 typography--color-disabled pb-5"
                        },
                        [_vm._v(_vm._s(_vm.$t("common.loading")))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-12 text-center mb-5 pb-5",
                    attrs: { slot: "no-more" },
                    slot: "no-more"
                  })
                ]
              )
            ],
            2
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47b65782", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b65782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/AddToSeriesModal.vue
// module id = zkyY
// module chunks = 1